import React, { FC, useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { AppRoutes } from '@/routes';
import { faFileContract, PageContainer, Title } from '@/ui/components';
import { TemplateEditorPanel } from './components/TemplateEditorPanel';

export const TemplateEditorPage: FC = () => {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const { accent } = useTheme();

  const toList = useCallback(
    () => navigate(AppRoutes.questionnaireTemplates),
    [navigate],
  );

  const templateId = id === undefined ? undefined : Number(id);
  if (templateId !== undefined && !Number.isInteger(templateId)) {
    return <Navigate to={AppRoutes.questionnaireTemplates} replace />;
  }

  return (
    <PageContainer>
      <Title
        title="Questionnaire Templates"
        icon={faFileContract}
        color={accent}
      />
      <TemplateEditorPanel
        templateId={templateId}
        onDone={toList}
        onCancel={toList}
      />
    </PageContainer>
  );
};
